// UI strings for the be.found.as editor, keyed by the English source string.
// Missing keys fall back to English.
const es: Record<string, string> = {
  "+ Add cover photo": "+ Añadir foto de portada",
  "1 Rue de Rivoli, Paris": "Calle Mayor 1, Madrid",
  "A bare domain can't use a CNAME, so it takes two steps. First, if your DNS provider offers an ALIAS or ANAME record (or CNAME flattening), point {domain} at this name — we keep it aimed at our servers, so it never needs updating:":
    "Un dominio raíz no puede usar un CNAME, así que son dos pasos. Primero, si tu proveedor de DNS ofrece registros ALIAS o ANAME (o CNAME flattening), apunta {domain} a este nombre — nosotros lo mantenemos dirigido a nuestros servidores, así que nunca hay que actualizarlo:",
  "A domain you own can show this page. Your found.as address keeps working — the domain is an extra way in, and you can remove it anytime.":
    "Un dominio tuyo puede mostrar esta página. Tu dirección found.as sigue funcionando — el dominio es una vía extra de entrada, y puedes quitarlo cuando quieras.",
  "A line or two of text": "Una o dos líneas de texto",
  Accent: "Acento",
  "Accent color — left/right arrows change the hue, up/down how colorful":
    "Color de acento — las flechas izquierda/derecha cambian el tono, arriba/abajo la intensidad",
  Access: "Acceso",
  "Add a name, photo, description, or link.":
    "Añade un nombre, foto, descripción o enlace.",
  "Add a video link.": "Añade un enlace de video.",
  "Add an image": "Añadir una imagen",
  "Add photo": "Añadir foto",
  "Add row": "Añadir fila",
  "Add to your page": "Añadir a tu página",
  Address: "Dirección",
  Advanced: "Avanzado",
  "Advanced format": "Formato avanzado",
  "Allow access": "Permitir acceso",
  "Allow pop-ups to open the print page.":
    "Permite las ventanas emergentes para abrir la página de impresión.",
  "Any family from the {catalog}. Google is never involved.":
    "Cualquier familia del {catalog}. Google nunca interviene.",
  Authorize: "Autorizar",
  Auto: "Automático",
  "Auto follows each visitor's device":
    "Automático sigue el dispositivo de cada visitante",
  "Auto follows each visitor's device — check both looks here":
    "Automático sigue el dispositivo de cada visitante — comprueba ambos aspectos aquí",
  "Automatic preview image": "Imagen de vista previa automática",
  Background: "Fondo",
  Backup: "Copia de seguridad",
  Badge: "Insignia",
  "Blank password — anyone who opens this editor address can change your page.":
    "Contraseña vacía — cualquiera que abra esta dirección del editor puede cambiar tu página.",
  "Blur behind": "Desenfocar detrás",
  "Button text": "Texto del botón",
  "Button transparency": "Transparencia del botón",
  Buttons: "Botones",
  "Can't sign in": "No se puede iniciar sesión",
  Cancel: "Cancelar",
  Canvas: "Lienzo",
  "Cards & poster": "Tarjetas y póster",
  "Change address": "Cambiar dirección",
  "Change password": "Cambiar contraseña",
  "Check now": "Comprobar ahora",
  "Checking availability…": "Comprobando disponibilidad…",
  "Checking this sign-in request…":
    "Comprobando esta solicitud de inicio de sesión…",
  "Choose a file under 5MB.": "Elige un archivo de menos de 5MB.",
  Circle: "Círculo",
  Close: "Cerrar",
  Colors: "Colores",
  Connect: "Conectar",
  Contact: "Contacto",
  "Contact buttons": "Botones de contacto",
  "Contact card": "Tarjeta de contacto",
  "Contact page": "Página de contacto",
  "Contact page editor": "Editor de página de contacto",
  Content: "Contenido",
  Continue: "Continuar",
  "Continue as {identity}": "Continuar como {identity}",
  "Copied as plain text": "Copiado como texto sin formato",
  "Copied ✓": "Copiado ✓",
  Copy: "Copiar",
  "Copy link": "Copiar enlace",
  "Copy plain text": "Copiar texto sin formato",
  "Copy signature": "Copiar firma",
  "Copy {type} value": "Copiar el valor {type}",
  "Copy, then paste into your email app's signature settings.":
    "Copia y pega en los ajustes de firma de tu aplicación de correo.",
  Corners: "Esquinas",
  "Could not compress that image.": "No se pudo comprimir esa imagen.",
  "Could not prepare the icon.": "No se pudo preparar el icono.",
  "Could not prepare the image.": "No se pudo preparar la imagen.",
  "Could not read that icon.": "No se pudo leer ese icono.",
  "Could not read that image.": "No se pudo leer esa imagen.",
  "Could not read the image.": "No se pudo leer la imagen.",
  "Couldn't render the social preview image — publishing the page without it.":
    "No se pudo generar la imagen de vista previa social — publicando la página sin ella.",
  Cover: "Portada",
  "Choose a password": "Elige una contraseña",
  "Create page": "Crear página",
  "Cropped to 1200×630 and served with your page. Until you add one, links share without an image.":
    "Recortada a 1200×630 y servida con tu página. Hasta que añadas una, los enlaces se comparten sin imagen.",
  "Custom link": "Enlace personalizado",
  "Custom preview image": "Imagen de vista previa personalizada",
  "Custom preview image that will be published":
    "Imagen de vista previa personalizada que se publicará",
  Dark: "Oscuro",
  "Darken by": "Oscurecer un",
  "Delete page": "Eliminar página",
  "Delete permanently": "Eliminar permanentemente",
  "Design sections": "Secciones de diseño",
  "Domain you own": "Dominio propio",
  Dots: "Puntos",
  "Drag to reorder": "Arrastra para reordenar",
  "Drag to resize the preview":
    "Arrastra para cambiar el tamaño de la vista previa",
  "Edit page": "Editar página",
  Email: "Correo",
  "Email signature": "Firma de correo",
  "Emoji icon": "Icono de emoji",
  "Enter a Bluesky handle or link.":
    "Introduce un identificador o enlace de Bluesky.",
  "Enter a Bluesky handle.": "Introduce un identificador de Bluesky.",
  "Enter a Cash App cashtag or link.":
    "Introduce un cashtag o enlace de Cash App.",
  "Enter a Cash App cashtag.": "Introduce un cashtag de Cash App.",
  "Enter a Mastodon address or link.":
    "Introduce una dirección o enlace de Mastodon.",
  "Enter a Matrix ID or link.": "Introduce un ID o enlace de Matrix.",
  "Enter a Substack name or link.": "Introduce un nombre o enlace de Substack.",
  "Enter a WhatsApp phone number.":
    "Introduce un número de teléfono de WhatsApp.",
  "Enter a YouTube, Vimeo, or PeerTube link.":
    "Introduce un enlace de YouTube, Vimeo o PeerTube.",
  "Enter a domain like yourname.com.":
    "Introduce un dominio como tunombre.com.",
  "Enter a phone number.": "Introduce un número de teléfono.",
  "Enter a redirect destination before publishing.":
    "Introduce un destino de redirección antes de publicar.",
  "Enter a valid Bluesky link.": "Introduce un enlace válido de Bluesky.",
  "Enter a valid Cash App link.": "Introduce un enlace válido de Cash App.",
  "Enter a valid Mastodon link.": "Introduce un enlace válido de Mastodon.",
  "Enter a valid Matrix link.": "Introduce un enlace válido de Matrix.",
  "Enter a valid Substack link.": "Introduce un enlace válido de Substack.",
  "Enter a valid email address.": "Introduce una dirección de correo válida.",
  "Enter a valid map link.": "Introduce un enlace de mapa válido.",
  "Enter a valid redirect destination before publishing.":
    "Introduce un destino de redirección válido antes de publicar.",
  "Enter a valid web address.": "Introduce una dirección web válida.",
  "Enter a valid {label} link.": "Introduce un enlace válido de {label}.",
  "Enter a valid {service} link.": "Introduce un enlace válido de {service}.",
  "Enter a {label} link.": "Introduce un enlace de {label}.",
  "Enter a {service} username or link.":
    "Introduce un nombre de usuario o enlace de {service}.",
  "Enter a {service} username.": "Introduce un nombre de usuario de {service}.",
  "Enter an Instagram username or link.":
    "Introduce un nombre de usuario o enlace de Instagram.",
  "Enter an address or map link.":
    "Introduce una dirección o un enlace de mapa.",
  "Enter an email address.": "Introduce una dirección de correo.",
  "Enter an https:// {label} link.": "Introduce un enlace https:// de {label}.",
  "Enter the existing password": "Introduce la contraseña actual",
  "Export backup (.zip)": "Exportar copia de seguridad (.zip)",
  Fallback: "Alternativa",
  "Favicon emoji": "Emoji del favicon",
  "Feature this link": "Destacar este enlace",
  Featured: "Destacado",
  "Featured — hidden until complete.": "Destacado — oculto hasta completarlo.",
  File: "Archivo",
  "File to publish": "Archivo a publicar",
  Fill: "Rellenar",
  Filled: "Relleno",
  "Finish the Instagram link or username.":
    "Completa el enlace o nombre de usuario de Instagram.",
  "Finish the {label} link.": "Completa el enlace de {label}.",
  "Fit whole image": "Mostrar la imagen completa",
  Font: "Fuente",
  Forget: "Olvidar",
  "Forget on this device": "Olvidar en este dispositivo",
  "Format the text": "Dar formato al texto",
  "Found it! Securing {domain} — this usually takes under a minute…":
    "¡Encontrado! Asegurando {domain} — esto suele tardar menos de un minuto…",
  "Google Fonts catalog ↗": "catálogo de Google Fonts ↗",
  "Google review": "Reseña de Google",
  Gradient: "Degradado",
  Grid: "Cuadrícula",
  "HTML content": "Contenido HTML",
  Heading: "Encabezado",
  Height: "Altura",
  "Hidden until complete.": "Oculto hasta completarlo.",
  "Hidden until it has text.": "Oculto hasta que tenga texto.",
  "Hidden.": "Oculto.",
  Hide: "Ocultar",
  "Host one file up to 5MB.": "Aloja un archivo de hasta 5MB.",
  "Icon lookup failed ({status}).": "La búsqueda del icono falló ({status}).",
  "Icon saved into your page.": "Icono guardado en tu página.",
  Image: "Imagen",
  "Import backup": "Importar copia de seguridad",
  "Import icon": "Importar icono",
  "Imported — review and publish to make it live.":
    "Importado — revisa y publica para ponerlo en línea.",
  "Importing…": "Importando…",
  "In your Google Business Profile, use “Ask for reviews” to copy your review link — it looks like":
    "En tu Perfil de Empresa de Google, usa “Solicitar reseñas” para copiar tu enlace de reseña — se parece a",
  "Include on business cards": "Incluir en tarjetas de visita",
  Language: "Idioma",
  "Lets visitors download a contact card (.vcf). It appears once the page has a name and a shown phone or email.":
    "Permite a los visitantes descargar una tarjeta de contacto (.vcf). Aparece cuando la página tiene un nombre y un teléfono o correo visibles.",
  Light: "Claro",
  "Lighten by": "Aclarar un",
  "Links for web, email, social, phone, and more.":
    "Enlaces para web, correo, redes sociales, teléfono y más.",
  "Loading…": "Cargando…",
  Looks: "Aspecto",
  "Lowercase letters, numbers and hyphens make the best address — capitals and special characters are harder to type and share.":
    "Las minúsculas, los números y los guiones hacen la mejor dirección — las mayúsculas y los caracteres especiales son más difíciles de escribir y compartir.",
  "Main address": "Dirección principal",
  "Manage domains": "Gestionar dominios",
  "Markdown content": "Contenido Markdown",
  "Markdown: {bold}, {italic}, links, lists and headings.":
    "Markdown: {bold}, {italic}, enlaces, listas y encabezados.",
  "Mathematician · first computer programmer":
    "Matemática · primera programadora",
  Menu: "Menú",
  "Move page": "Mover página",
  "Move {label} down": "Mover {label} hacia abajo",
  "Move {label} up": "Mover {label} hacia arriba",
  Name: "Nombre",
  "Need a public email address? Create a forwarding alias at":
    "¿Necesitas una dirección de correo pública? Crea un alias de reenvío en",
  "New address": "Nueva dirección",
  "New page path": "Nueva ruta de la página",
  "New password": "Nueva contraseña",
  "No ALIAS support? Use a subdomain like {www} instead — it takes a plain CNAME.":
    "¿Sin soporte de ALIAS? Usa un subdominio como {www} — acepta un CNAME normal.",
  "No contact buttons yet.": "Aún no hay botones de contacto.",
  "No icon found for that site.": "No se encontró icono para ese sitio.",
  "No priv.cbor found in this file.":
    "No se encontró priv.cbor en este archivo.",
  None: "Ninguno",
  "Not a ZIP file.": "No es un archivo ZIP.",
  "Now at found.as/{target}.": "Ahora en found.as/{target}.",
  "On a subdomain instead (like www.{domain})?":
    "¿Mejor en un subdominio (como www.{domain})?",
  "One CNAME on {domain} pointing to the address above. It connects the domain and proves it's yours in a single record.":
    "Un CNAME en {domain} apuntando a la dirección de arriba. Conecta el dominio y demuestra que es tuyo en un solo registro.",
  "Online in seconds": "En línea en segundos",
  Open: "Abrir",
  "Open your public page": "Abrir tu página pública",
  "Optional line under the button": "Línea opcional bajo el botón",
  "Or upload a separate dark image": "O sube una imagen oscura aparte",
  Outline: "Contorno",
  "Page link": "Enlace de la página",
  "Page password": "Contraseña de la página",
  "Page path": "Ruta de la página",
  "Page preview": "Vista previa de la página",
  "Page type": "Tipo de página",
  "Password changed — save a fresh recovery kit.":
    "Contraseña cambiada — guarda un kit de recuperación nuevo.",
  "Paste a valid Google review link.":
    "Pega un enlace de reseña de Google válido.",
  "Paste your Google review link.": "Pega tu enlace de reseña de Google.",
  Phone: "Teléfono",
  "Photo shape": "Forma de la foto",
  "Pick an address and a password. No account, no cookies.":
    "Elige una dirección y una contraseña. Sin cuenta, sin cookies.",
  Pill: "Píldora",
  Platforms: "Plataformas",
  "Preparing…": "Preparando…",
  Preview: "Vista previa",
  "Preview appearance": "Aspecto de la vista previa",
  "Preview description": "Descripción de la vista previa",
  "Preview fallback": "Previsualizar la alternativa",
  "Preview image appearance": "Aspecto de la imagen de vista previa",
  "Preview image that will be published":
    "Imagen de vista previa que se publicará",
  "Preview title": "Título de la vista previa",
  "Profile email": "Correo del perfil",
  Publish: "Publicar",
  "Publish a custom HTML page.": "Publica una página HTML personalizada.",
  "Publish to {host}": "Publicar en {host}",
  "QR code type": "Tipo de código QR",
  Redirect: "Redirección",
  "Redirect destination": "Destino de la redirección",
  "Redirect, markdown page, HTML page, or file.":
    "Redirección, página Markdown, página HTML o archivo.",
  "Refresh icon": "Actualizar icono",
  "Remember on this device": "Recordar en este dispositivo",
  "Remembered on this device": "Recordado en este dispositivo",
  Remove: "Quitar",
  "Remove dark image": "Quitar imagen oscura",
  "Remove icon": "Quitar icono",
  "Remove {label}": "Quitar {label}",
  Replace: "Reemplazar",
  "Replace dark image": "Reemplazar imagen oscura",
  "Replace image": "Reemplazar imagen",
  Rounded: "Redondeada",
  "Rounded square": "Cuadrado redondeado",
  Save: "Guardar",
  "Save QR": "Guardar QR",
  "Save QR code": "Guardar código QR",
  "Save contact": "Guardar contacto",
  "Save contact button label": "Etiqueta del botón de guardar contacto",
  "Save recovery kit": "Guardar kit de recuperación",
  "Saves this page's key in this browser so future sign-ins skip the password. Only on a device you trust.":
    "Guarda la clave de esta página en este navegador para que los próximos inicios de sesión no pidan la contraseña. Solo en un dispositivo de confianza.",
  "Saves this page's key in this browser so it opens without the password. Only on a device you trust.":
    "Guarda la clave de esta página en este navegador para que se abra sin la contraseña. Solo en un dispositivo de confianza.",
  "Search fonts…": "Buscar fuentes…",
  "Section header": "Encabezado de sección",
  "Send visitors to one web address.":
    "Envía a los visitantes a una dirección web.",
  Share: "Compartir",
  Sharing: "Compartir",
  Sharp: "Rectas",
  "Short description": "Descripción corta",
  Show: "Mostrar",
  "Show an icon on this button — type an emoji, or import the site's icon. It's fetched once and saved into your page.":
    "Muestra un icono en este botón — escribe un emoji o importa el icono del sitio. Se obtiene una vez y se guarda en tu página.",
  "Show an icon on this button — type any emoji.":
    "Muestra un icono en este botón — escribe cualquier emoji.",
  "Show on page": "Mostrar en la página",
  "Shown as a heading.": "Se muestra como encabezado.",
  "Shown as a video.": "Se muestra como video.",
  "Shown as text.": "Se muestra como texto.",
  "Shown in the browser tab.": "Se muestra en la pestaña del navegador.",
  "Sign in": "Iniciar sesión",
  "Sign in wherever you manage {domain}'s DNS — usually where you bought it — and add a CNAME record:":
    "Inicia sesión donde gestiones el DNS de {domain} — normalmente donde lo compraste — y añade un registro CNAME:",
  "Sign-in": "Inicio de sesión",
  "Signature preview": "Vista previa de la firma",
  "Signing in…": "Iniciando sesión…",
  Soft: "Suaves",
  "Start writing GitHub-flavored markdown.\n\nOptional front matter:\n---\ntitle: Page title\n---":
    "Empieza a escribir markdown estilo GitHub.\n\nFront matter opcional:\n---\ntitle: Título de la página\n---",
  "Start writing HTML": "Empieza a escribir HTML",
  "Status line": "Línea de estado",
  Style: "Estilo",
  Subtitle: "Subtítulo",
  System: "Sistema",
  "TXT record": "Registro TXT",
  Text: "Texto",
  "That file is over 5MB. Choose a smaller file.":
    "Ese archivo supera los 5MB. Elige uno más pequeño.",
  "That icon is too large.": "Ese icono es demasiado grande.",
  "That password doesn't match this page.":
    "Esa contraseña no corresponde a esta página.",
  "That site did not return an icon.": "Ese sitio no devolvió un icono.",
  "The address featured on your QR code, printables and email signature. Your page stays reachable at every address either way.":
    "La dirección que aparece en tu código QR, imprimibles y firma de correo. Tu página sigue accesible en todas las direcciones de todos modos.",
  Theme: "Tema",
  "Theme default": "Predeterminado del tema",
  "Then add this record so we know the domain is yours:":
    "Luego añade este registro para que sepamos que el dominio es tuyo:",
  "There is no password reset. Once you're in, save the recovery kit from the menu — it keeps your address and password somewhere safe.":
    "No hay restablecimiento de contraseña. Cuando entres, guarda el kit de recuperación desde el menú — conserva tu dirección y contraseña en un lugar seguro.",
  "This address already exists — password unlocked. Continue to edit it.":
    "Esta dirección ya existe — contraseña desbloqueada. Continúa para editarla.",
  "This address exists. Enter its password to edit, or pick another address.":
    "Esta dirección existe. Introduce su contraseña para editar, o elige otra dirección.",
  "This address isn't a found.as page.":
    "Esta dirección no es una página de found.as.",
  "This domain is already connected to another page.":
    "Este dominio ya está conectado a otra página.",
  "This is really me": "Realmente soy yo",
  "This permanently removes found.as/{path} and releases any custom domains. There's no undo.":
    "Esto elimina permanentemente found.as/{path} y libera cualquier dominio propio. No se puede deshacer.",
  "This replaces your page's key, so any recovery kit you've saved stops working — save a fresh one afterwards.":
    "Esto reemplaza la clave de tu página, así que cualquier kit de recuperación guardado deja de funcionar — guarda uno nuevo después.",
  "This sign-in request is missing required details.":
    "A esta solicitud de inicio de sesión le faltan datos obligatorios.",
  "This sign-in request isn't supported.":
    "Esta solicitud de inicio de sesión no es compatible.",
  "Type {path} to confirm": "Escribe {path} para confirmar",
  "Update password": "Actualizar contraseña",
  "Upload an image": "Subir una imagen",
  "Use @you:server.org, or paste a matrix.to link.":
    "Usa @you:server.org o pega un enlace de matrix.to.",
  "Use @you@server, or paste your profile link.":
    "Usa @you@server o pega el enlace de tu perfil.",
  "Use the cover as the page's name":
    "Usar la portada como nombre de la página",
  "Use this to edit later": "Usa esto para editar más tarde",
  "Using a bare domain like example.com?":
    "¿Usas un dominio raíz como example.com?",
  "Video link": "Enlace de video",
  "We check every few seconds — you can close this window and come back later.":
    "Comprobamos cada pocos segundos — puedes cerrar esta ventana y volver más tarde.",
  "We couldn't secure {domain} after repeated attempts. Remove it, check your DNS records, and try again.":
    "No pudimos asegurar {domain} tras varios intentos. Quítalo, revisa tus registros DNS y vuelve a intentarlo.",
  Website: "Sitio web",
  "Which address an app receives when someone signs in with your page and allows the email permission.":
    "La dirección que recibe una aplicación cuando alguien inicia sesión con tu página y permite el permiso de correo.",
  Work: "Trabajo",
  "Working…": "Procesando…",
  "Works offline": "Funciona sin conexión",
  "Write a simple page with Markdown.":
    "Escribe una página sencilla con Markdown.",
  "You're live 🎉": "Ya estás en línea 🎉",
  "Your HTML page is live.": "Tu página HTML está en línea.",
  "Your address": "Tu dirección",
  "Your contact page is live.": "Tu página de contacto está en línea.",
  "Your file is live.": "Tu archivo está en línea.",
  "Your markdown page is live.": "Tu página Markdown está en línea.",
  "Your page moves to the new address. The old one stops working, and any custom domains follow automatically.":
    "Tu página se muda a la nueva dirección. La antigua deja de funcionar, y cualquier dominio propio la sigue automáticamente.",
  "Your page password": "La contraseña de tu página",
  "Your password never leaves this device — it only signs the approval.":
    "Tu contraseña nunca sale de este dispositivo — solo firma la aprobación.",
  "Your redirect is live.": "Tu redirección está en línea.",
  crimson: "carmesí",
  "e.g. New": "p. ej. Nuevo",
  "e.g. ☕": "p. ej. ☕",
  forest: "bosque",
  "found.as home — switch to another page":
    "inicio de found.as — cambiar a otra página",
  "found.as/{path} is available.": "found.as/{path} está disponible.",
  gold: "dorado",
  graphite: "grafito",
  "hue {hue}°, {pct}% colorful": "tono {hue}°, {pct}% de intensidad",
  live: "activo",
  "needs attention": "necesita atención",
  ocean: "océano",
  rust: "óxido",
  "securing…": "asegurando…",
  "theme default": "predeterminado del tema",
  violet: "violeta",
  "youtube.com, vimeo.com, or a PeerTube link":
    "youtube.com, vimeo.com o un enlace de PeerTube",
  "{client} wants to access your found.as page with these permissions:":
    "{client} quiere acceder a tu página de found.as con estos permisos:",
  "{client} wants to confirm you own this found.as page.":
    "{client} quiere confirmar que esta página de found.as es tuya.",
  "{domain} isn't connected yet.": "{domain} aún no está conectado.",
  "{index} of {total}": "{index} de {total}",
  "{link} is live.": "{link} está en línea.",
  "{name} is ready to publish.": "{name} está listo para publicar.",
  "▶ Add a video": "▶ Añadir un video",
  "✓ We can see your proof record — now waiting for {domain} to route to us, usually just the DNS change spreading.":
    "✓ Ya vemos tu registro de prueba — ahora esperamos a que {domain} nos dirija el tráfico, normalmente solo es el cambio de DNS propagándose.",
  "✓ {domain} is reaching us. Now add the record that proves it's yours — the {record} below.":
    "✓ {domain} ya nos alcanza. Ahora añade el registro que demuestra que es tuyo — el {record} de abajo.",
  "🟢 Status (optional)": "🟢 Estado (opcional)",
};

export default es;
